<template>
  <div>
    <vx-card class="mb-8">
      <div class="search-container mb-6 px-0">
        <div class="vx-row w-full flex justify-between items-center no-margin">
          <div class="flex-grow flex items-center">
            <div class="vx-col min-w-300 mr-4 pl-0">
              <vs-input
                v-model="searchText"
                placeholder="Search..."
                class="w-full search-field"
                icon-pack="feather"
                icon="icon-search"
                icon-no-border
                @keyup.enter="search"
              />
            </div>
          </div>
        </div>
      </div>
      <vs-table stripe :data="tableData">
        <template slot="thead">
          <vs-th class="text-left table-header-style">No</vs-th>

          <vs-th @click="toggleSort('siteName')" class="text-left table-header-style cursor-pointer">
            <div class="flex items-center">
              <span>Site Name</span>
              <div class="ml-4 flex flex-col sort-icon-group" @click.stop="toggleSort('siteName')" style="cursor: pointer">
                <font-awesome-icon :icon="['fas', 'caret-up']" :class="getSortClass('siteName', 'asc')" />
                <font-awesome-icon :icon="['fas', 'caret-down']" :class="getSortClass('siteName', 'desc')" />
              </div>
            </div>
          </vs-th>

          <vs-th class="text-left table-header-style">
            <div class="flex items-center">
              <span>Platform</span>
            </div>
          </vs-th>

          <!-- <vs-th class="text-center table-header-style">
            <div class="flex items-center justify-center">
              <span>Platform Logo</span>
            </div>
          </vs-th> -->

          <vs-th @click="toggleSort('statusServer')" class="text-center table-header-style cursor-pointer">
            <div class="flex items-center justify-center">
              <span>Status Server</span>
              <div class="ml-4 flex flex-col sort-icon-group" @click.stop="toggleSort('statusServer')" style="cursor: pointer">
                <font-awesome-icon :icon="['fas', 'caret-up']" :class="getSortClass('statusServer', 'asc')" />
                <font-awesome-icon :icon="['fas', 'caret-down']" :class="getSortClass('statusServer', 'desc')" />
              </div>
            </div>
          </vs-th>

          <vs-th @click="toggleSort('statusWebEndpoint')" class="text-center table-header-style cursor-pointer">
            <div class="flex items-center justify-center">
              <span>Status Web Endpoint</span>
              <div class="ml-4 flex flex-col sort-icon-group" @click.stop="toggleSort('statusWebEndpoint')" style="cursor: pointer">
                <font-awesome-icon :icon="['fas', 'caret-up']" :class="getSortClass('statusWebEndpoint', 'asc')" />
                <font-awesome-icon :icon="['fas', 'caret-down']" :class="getSortClass('statusWebEndpoint', 'desc')" />
              </div>
            </div>
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="indextr">
              {{ (currentPage - 1) * itemsPerPage + indextr + 1 }}
            </vs-td>

            <vs-td class="text-left" :data="tr.siteName">
              {{ tr.siteName }}
            </vs-td>

            <!-- <vs-td class="text-left" :data="tr.name">
              {{ tr.name }}
            </vs-td> -->

            <vs-td class="text-center" :data="tr.name">
              <img :src="getPlatformLogo(tr.name)" :alt="tr.name" class="platform-logo" />
            </vs-td>

            <vs-td class="text-center" :data="tr.statusServer">
              <div class="flex justify-center items-center">
                <vs-chip :color="tr.statusServer ? '#4CAF50' : '#9E9E9E'" icon-pack="feather">
                  {{ tr.statusServer ? 'Online' : 'Offline' }}
                </vs-chip>
              </div>
            </vs-td>

            <vs-td class="text-center" :data="tr.statusWebEndpoint">
              <div class="flex justify-center items-center">
                <vs-chip :color="tr.statusWebEndpoint ? '#4CAF50' : '#9E9E9E'" icon-pack="feather">
                  {{ tr.statusWebEndpoint ? 'Online' : 'Offline' }}
                </vs-chip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="flex justify-between mt-4">
        <div class="flex" style="align-items: center">
          <span class="mr-2">show data</span>
          <vs-select
            style="width: 25%"
            v-model="itemsPerPage"
            @input="updateItemsPerPage"
          >
            <vs-select-item
              v-for="(option, index) in pageOptions"
              :key="index"
              :value="option.value"
              :text="option.text"
            />
          </vs-select>
        </div>
        <CustomPagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
          :total-data="totalData"
          @update:currentPage="getBuilding"
        />
      </div>
    </vx-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import CustomPagination from "@/components/CustomPagination.vue";
import api from "@/api";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCaretUp, faCaretDown);

export default {
  components: {
    DatePicker,
    CustomPagination,
    "font-awesome-icon": FontAwesomeIcon,
  },
  data() {
    return {
      searchText: "",
      daterange: null,
      currentPage: 1,
      itemsPerPage: 10,
      pageOptions: [
        { value: 3, text: '3' },
        { value: 5, text: '5' },
        { value: 10, text: '10' }
      ],
      tableData: [],
      totalData: 0,
      totalPages: 0,
      // sorting
      sortField: "",
      sortOrder: "asc",
    };
  },
  
  methods: {
    updateItemsPerPage() {
      this.currentPage = 1;
      this.getPlatforms();
    },
    notAferToday(date) {
      return date > new Date(new Date().setHours(23, 59, 0, 0));
    },
    search() {
      // Trigger fetch on enter
      this.currentPage = 1;
      this.getBuilding();
    },
    refreshData() {
      this.searchText = "";
      this.daterange = null;
      this.currentPage = 1;
      this.getPlatforms();
    },
    // Main fetch method for platforms
    getPlatforms() {
      this.$vs.loading();
      const params = {
        search: this.searchText,
        Page: this.currentPage,
        Limit: this.itemsPerPage,
      };

      if (this.sortField) {
        params.SortBy = this.sortField;
        params.SortDir = this.sortOrder;
      }

      console.log("📦 [getPlatforms] API Params:", params);

      // call api.platform (defined in src/api/index.js)
      api
        .platform(params)
        .then((result) => result.data)
        .then((data) => {
          console.log("✅ [getPlatforms] Response:", data);
          if (data.status) {
            this.tableData = data.data || [];
            this.totalData = data.totalData || 0;
            // maxPage maps to total pages
            this.totalPages = data.maxPage || Math.ceil((data.totalData || 0) / this.itemsPerPage);
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.error("❌ [getPlatforms] Error:", e);
          this.$vs.loading.close();
        });
    },
    // keep existing getBuilding name in template wiring
    getBuilding() {
      this.getPlatforms();
    },
    // sorting helpers
    toggleSort(field) {
      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.getPlatforms();
    },
    getSortClass(field, direction) {
      const isActive = this.sortField === field && this.sortOrder === direction;
      return {
        "sort-icon": true,
        active: isActive,
      };
    },
    getPlatformLogo(platformName) {
      const logoMap = {
        'avigilon': require('@/assets/images/logo/avigilon_logo_svg.svg'),
        'dahua': require('@/assets/images/logo/dahua_logo_svg.svg'),
        'hikvision': require('@/assets/images/logo/hikvision_logo_svg.svg')
      };
      const lowerName = platformName.toLowerCase();
      return logoMap[lowerName] || null;
    },
  },
  mounted() {
    this.getPlatforms();
  },
};
</script>

<style scoped>
.search-container {
  width: 100%;
}

.no-margin {
  margin: 0;
}

.search-field {
  min-width: 300px;
}

.date-picker-field {
  min-width: 220px;
}

.download-button {
  padding-right: 1rem;
}

.large-faicon {
  font-size: 42px;
  color: #1372ac;
  margin-right: 0;
}

.box.toggle-chart {
  cursor: pointer;
}

.cursor-pointer {
  cursor: pointer;
}

/* Style adjustments for the table */
.vs-table {
  margin-top: 1rem;
  width: 100%;
  border: 1px solid #eee;
  border-radius: 8px;
}

.table-header-style {
  font-weight: 600;
  color: #444;
  padding: 1rem;
}

.vs-table--thead {
  background-color: #f8f8f8;
}

.vs-table--tbody > .vs-table--tr {
  border-bottom: 1px solid #eee;
}

.vs-table--td {
  padding: 0.75rem 1rem;
}

.platform-logo {
  height: 20px;
  width: auto;
  object-fit: contain;
}
</style>
